import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { ListTriggerElement as ListTriggerElementModel } from '../../../../models/ConversationHistory/HistoryElement/TriggerHistoryElement/ListTriggerElement';
import rootStore from '../../../../stores/rootStore';
import BaseHistoryElement from '../BaseHistoryElement';
import { useGetIcon } from '../../../customHooks/useGetIcon';

interface IProps {
  element: ListTriggerElementModel;
}

const ListTriggerElement: React.FC<IProps> = ({ element }: IProps) => {
  const getIcon = useGetIcon();
  const { blockStore } = useContext(rootStore);
  const block = blockStore?.allBlocks?.find(
    (block) => block?.trigger?.id === element.triggerId
  );

  return (
    <BaseHistoryElement element={element} title='List Trigger evaluated' icon={getIcon('list_trigger')} >
      {element.triggered ? (
        <div className='card-paragraph'>
          <i className={getIcon('check')}> </i>
          <span> Triggered block "{block?.title}" </span>
        </div>
      ) : (
        <div className='card-paragraph'>
          <i className={getIcon('error')}> </i>
          <span> Not triggered block "{block?.title}" </span>
        </div>
      )}
    </BaseHistoryElement>
  );
};

export default observer(ListTriggerElement);
